module.exports = __webpack_public_path__ + "static/media/nu.40dfde43.svg";